var exports = {
  "kL": "container__JwXLSQ",
  "h4": "imageWrapper__8PslnG",
  "D3": "imageFlex__JtR-qh",
  "ZS": "imageContainer__7UBJm6",
  "qy": "contentColumn__hs26DD",
  "bL": "footerWrapper__fTkaAt",
};

module.exports = exports;
